var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.7 56.7",
    style: {
      enableBackground: "new 0 0 56.7 56.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C8C7C7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.9,24.7c-2.4-1.4-4.9-2.9-7.3-4.3C30,19,27.5,17.5,24.8,16c-2.7-1.4-5.6,0.3-5.6,3.4 c-0.1,5.7,0,11.4-0.1,17.8c-0.1,0.7,0.1,1.2,0.3,1.8c0.3,0.5,0.6,1,1.1,1.4c1.5,1.3,2.9,1.3,4.9,0.2c4.9-2.8,9.7-5.6,14.5-8.4 c1.4-0.8,2.4-1.8,2.4-3.5C42.5,26.8,41.4,25.6,39.9,24.7z M39.3,30.6c-5,3-10.1,5.9-15.1,8.8c-1.6,0.9-3.3,0-3.4-1.9 c0-0.6,0.1-1,0-1.6c0-5.3,0-10.6,0-15.8c0-2.1,1.8-3.3,3.7-2.1c4.9,2.9,9.9,5.7,14.8,8.5C41.1,27.5,41.1,29.4,39.3,30.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.1,2c3.1,0,5.6,2.5,5.6,5.6v41.5c0,3.1-2.5,5.6-5.6,5.6H7.6c-3.1,0-5.6-2.5-5.6-5.6V7.6C2,4.5,4.5,2,7.6,2 H49.1 M49.1,0H7.6C3.4,0,0,3.4,0,7.6v41.5c0,4.2,3.4,7.6,7.6,7.6h41.5c4.2,0,7.6-3.4,7.6-7.6V7.6C56.7,3.4,53.3,0,49.1,0L49.1,0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.4b984cf894c5f9299d3ec65094feb287.svg";
export { ForwardRef as ReactComponent };